import { useEffect, useRef, useState } from "react";
import { ISearchBox } from "@fluentui/react";
import { IDataTipoEquipo, IFilterTableTipoEquipo } from "../../../../Interfaces/ListaVerificacion/TipoEquipo/ITIpoEquipo";
import { IPaginacionComponent } from "../../../../Interfaces/filter";
import TipoEquipoService from "../../../../services/ListaVerificacion/TipoEquipoService";
import { IPaginationV2 } from "../../../../Interfaces/base/ITable";

export const UseTipoEquipoTable = () => {
  const [loading, setLoading] = useState<boolean>(false)
  const [items, setItems] = useState<IDataTipoEquipo[]>([])
  const onChangeSearch = useRef<ISearchBox>(null);
  const [filter, setFilter] = useState<IFilterTableTipoEquipo>({
    skip: 0,
    take: 50,
  });
  useEffect(() => {
    if (filter) {
      getTipoEquipo()
    }
  }, [filter])
  const inital: IFilterTableTipoEquipo = {
    skip: 0,
    take: 50,
  }
  const _onkeyUpSearchTable = (
    event: React.KeyboardEvent<HTMLInputElement>
  ) => {
    let { value } = event?.target as HTMLInputElement;
    setFilter({ ...filter, search: value });
  };

  const onChangeTake = (value: number) => {
    setFilter({ ...filter, take: value })
  };
  const onSkip = (value: number) => {
    const realSkip = (value * filter.take) - filter.take
    setFilter({ ...filter, skip: realSkip })
  };

  const handleResetUpdate = () => {
    setFilter(inital);
  };
  const [pagination, setPagination] = useState<IPaginationV2>({
    currentPage: 0,
    total: 0,
    pageSize: 0,
    skip: 0,
    take: 50,
    onPageChange: function (value: number): void {
    },
    onSizeChange: function (value: number): void {
    }
  })
  const getTipoEquipo = () => {
    setLoading(true)
    TipoEquipoService.ListarAuxiliares(filter).then((res) => {
      const pag: IPaginationV2 = {
        currentPage: res.data.page,
        total: res.data.total,
        pageSize: res.data.pages,
        onPageChange: onSkip,
        skip: filter.skip,
        take: filter.take,
        onSizeChange: onChangeTake
      };
      setPagination(pag)
      setLoading(false)
      setItems(res.data.items)
    }).catch((e: any) => {
      setLoading(false)
    })

  }
  return {
    items,
    filter,
    setFilter,
    loading,
    pagination,
    getTipoEquipo,
    handleResetUpdate,
    onChangeSearch,
    onChangeTake,
    _onkeyUpSearchTable,
  }
}